import React, { Component } from 'react';
import Vitae from '../../common/curriculumVitae';
import UserSider from '../UserSider';

class CurriculumVitae extends Component {
    render() {
        return (
            <div className="content">
                <UserSider selectKey='userResume' openKeys={['sub1']}/>
                <div className="main">
                    <div className="main-content">
                        <Vitae type="user" />
                    </div>
                </div>
            </div>
        );
    }
}

export default CurriculumVitae;


// WEBPACK FOOTER //
// ./src/components/user/curriculumVitae/index.js